<mat-toolbar class="topbar gap-5">
  <!-- --------------------------------------------------------------- -->
  <!-- Desktop Menu -->
  @if(showToggle()) {
    <button mat-icon-button (click)="toggleCollapsed.emit()" class="d-flex justify-content-center">
      <app-icon icon="solar:hamburger-menu-line-duotone" customClass="icon-24 d-flex" color="#0085db"></app-icon>
    </button>
  }

  <!-- --------------------------------------------------------------- -->
  <!-- Mobile Menu -->
  <!-- @if(!showToggle()) {
    <button mat-icon-button (click)="toggleMobileNav.emit()" class="d-flex justify-content-center align-items-center">
      <i class="iconify icon-20 d-flex" data-icon="solar:hamburger-menu-line-duotone"></i>
    </button>
  } -->
  <!-- --------------------------------------------------------------- -->

  <!-- --------------------------------------------------------------- -->
  <!-- Mobile Logo -->
  <!-- --------------------------------------------------------------- -->
  <app-branding [mini]="true" class="d-flex d-sm-none"></app-branding>

  <span class="flex-1-auto"></span>

  <!-- --------------------------------------------------------------- -->
  <!-- Search Button -->
  <!-- --------------------------------------------------------------- -->
  <button mat-icon-button (click)="openSearchDialog()" [matTooltip]="'layout.header.search' | translate"
    aria-label="Search" class="d-flex align-items-center justify-content-center m-r-5">
    <app-icon icon="solar:magnifer-line-duotone" customClass="icon-24 d-flex" color="#0085db"></app-icon>
  </button>

  <!-- --------------------------------------------------------------- -->
  <!-- Notification Dropdown -->
  <!-- --------------------------------------------------------------- -->
  <button mat-icon-button [matMenuTriggerFor]="notificationmenu" [matMenuTriggerRestoreFocus]="false"
    aria-label="Notifications" class="d-flex align-items-center justify-content-center m-r-5">
    <app-icon icon="solar:bell-line-duotone" customClass="icon-24 d-flex" color="#0085db"></app-icon>
    @if(newNotificationsCount() > 0) {
      <div class="notification bg-primary text-white rounded-circle f-s-10">{{ newNotificationsCount() }}</div>
    }
  </button>
  <mat-menu #notificationmenu="matMenu" class="topbar-dd notification-panel cardWithShadow">
    <div class="d-flex align-items-center p-x-32 p-y-16">
      <h6 class="f-s-16 f-w-600 m-0">{{ 'layout.header.activitiesOnMyFarm' | translate }}</h6>
    </div>

    <div class="notifications-scroll-container">
      @if(isLoadingActivityLogs() && notifications().length === 0) {
        <div class="p-x-32 p-y-16 text-center">
          <span class="text-muted">Loading...</span>
        </div>
      }
      @for(notification of notifications(); track notification.id; let i = $index) {
        <button mat-menu-item class="p-y-12" [appNotificationVisibilityTracker]="activityLogs()[i].created_at">
          <div class="d-flex align-items-center">
            <span class="flex-shrink-0 text-{{ notification.color }} bg-light-{{
            notification.color
          }} rounded-circle icon-32 d-flex align-items-center justify-content-center">
              <app-icon [icon]="notification.icon"
                [customClass]="'d-flex icon-16 text-' + notification.color"></app-icon>
            </span>
            <div class="m-l-12 w-100">
              <div class="d-flex align-items-center justify-content-between w-100">
                <h5 class="f-s-14 f-w-600 m-0">
                  {{ notification.title }}
                </h5>
                <span class="d-block f-s-12 m-l-auto text-muted">
                  {{ notification.time }}</span>
              </div>
              <span class="d-block text-truncate f-s-12 w-75 text-muted">{{
            notification.subtitle
          }}</span>
            </div>
          </div>
        </button>
      }
      @if(notifications().length === 0 && !isLoadingActivityLogs()) {
        <div class="p-x-32 p-y-16 text-center">
          <span class="text-muted">No notifications</span>
        </div>
      }
    </div>

    <div class="p-y-12 p-x-32">
      @if(hasMoreActivityLogs()) {
        <button mat-flat-button color="primary" class="w-100" (click)="loadMoreActivityLogs()"
          [disabled]="isLoadingActivityLogs()">
          {{ isLoadingActivityLogs() ? 'Loading...' : 'Load More' }}
        </button>
      } @else if(notifications().length > 0) {
        <div class="d-flex align-items-center justify-content-center text-muted f-s-12">
          <app-icon icon="solar:check-circle-line-duotone" customClass="icon-16 m-r-8 wave-animation"></app-icon>
          <span>{{ 'layout.header.noOtherActivities' | translate }}</span>
        </div>
      }
    </div>
  </mat-menu>

  <!-- --------------------------------------------------------------- -->
  <!-- Task Dropdown -->
  <!-- --------------------------------------------------------------- -->
  <button mat-icon-button [matMenuTriggerFor]="taskmenu" [matMenuTriggerRestoreFocus]="false"
    [matTooltip]="'layout.header.tasks.tooltip' | translate" aria-label="Tasks"
    class="d-flex align-items-center justify-content-center m-r-5">
    <app-icon icon="solar:checklist-line-duotone" customClass="icon-24 d-flex" color="#0085db"></app-icon>
    @if(taskCount() > 0) {
      <div class="notification bg-primary text-white rounded-circle f-s-10">{{ taskCount() }}</div>
    }
  </button>
  <mat-menu #taskmenu="matMenu" class="topbar-dd task-panel cardWithShadow">
    <div class="d-flex align-items-center p-x-32 p-y-16" (click)="$event.stopPropagation()">
      <h6 class="f-s-16 f-w-600 m-0">{{ 'layout.taskPanel.title' | translate }}</h6>
      @if(taskCount() > 0) {
        <span class="m-l-auto">
          <span class="bg-primary text-white p-x-8 p-y-4 f-w-500 rounded f-s-12">{{ taskCount() }}</span>
        </span>
      }
    </div>

    <div class="tasks-scroll-container" (click)="$event.stopPropagation()">
      <app-task-panel-menu [tasks]="headerTasks()" [showTabs]="true" [scrollHeight]="'400px'"></app-task-panel-menu>
    </div>

    <div class="p-y-12 p-x-32">
      <button mat-flat-button color="primary" class="w-100" routerLink="/app/tasks">
        {{ 'layout.taskPanel.viewAllTasks' | translate }}
      </button>
    </div>
  </mat-menu>

  <!-- --------------------------------------------------------------- -->
  <!-- Theme Toggle Button (hidden on mobile - available in user menu) -->
  <!-- --------------------------------------------------------------- -->
  <button mat-icon-button (click)="toggleTheme()" [matTooltip]="'layout.header.toggleTheme' | translate"
    aria-label="Toggle theme" class="d-none d-md-flex align-items-center justify-content-center m-r-5">
    <app-icon [icon]="isDarkTheme() ? 'solar:sun-line-duotone' : 'solar:moon-line-duotone'" customClass="icon-24 d-flex" color="#0085db"></app-icon>
  </button>

  <!-- --------------------------------------------------------------- -->
  <!-- Weather Dropdown -->
  <!-- --------------------------------------------------------------- -->
  @if (canShowWeather()) {
    <button mat-icon-button [matMenuTriggerFor]="weathermenu" [matMenuTriggerRestoreFocus]="false"
      [matTooltip]="'layout.header.weather.tooltip' | translate" aria-label="Weather"
      class="d-flex align-items-center justify-content-center m-r-5">
      <app-icon icon="solar:cloud-sun-2-line-duotone" customClass="icon-24 d-flex" color="#0085db"></app-icon>
    </button>
    <mat-menu #weathermenu="matMenu" class="topbar-dd weather-panel cardWithShadow">
      <app-weather-menu [data]="weatherData()"></app-weather-menu>
    </mat-menu>
  }

  <!-- --------------------------------------------------------------- -->
  <!-- Farm Display (Current Farm) -->
  <!-- --------------------------------------------------------------- -->

  <!-- Desktop Farm Button -->
  <app-mat3-button class="farm-context-button d-none d-md-flex" data-tour="nav-farms"
    [text]="currentFarmName() || ('common.selectedFarm.noFarmSelected' | translate)" variant="outlined" size="sm"
    beforeIcon="agriculture"
    [matTooltip]="currentFarm() ? ('common.selectedFarm.currentlySelected' | translate) : ('common.selectedFarm.selectFarm' | translate)"
    (buttonClick)="navigateToFarmList()">
  </app-mat3-button>
  <!-- Mobile Farm Button -->
  <app-mat3-button class="farm-context-button d-flex d-md-none" data-tour="nav-farms-mobile"
    [text]="currentFarmNameMobile() || ('common.selectedFarm.noFarmSelected' | translate)" variant="outlined" size="sm"
    [matTooltip]="currentFarm() ? ('common.selectedFarm.currentlySelected' | translate) : ('common.selectedFarm.selectFarm' | translate)"
    (buttonClick)="navigateToFarmList()">
  </app-mat3-button>

  <!-- --------------------------------------------------------------- -->
  <!-- langugage Dropdown -->
  <!-- --------------------------------------------------------------- -->
  <app-lang-selector [matTooltip]="'layout.header.selectLang' | translate" class="d-none d-sm-flex menu-button">
  </app-lang-selector>

  <!-- --------------------------------------------------------------- -->
  <!-- profile Dropdown -->
  <!-- --------------------------------------------------------------- -->
  <button mat-icon-button [matMenuTriggerFor]="profilemenu" [matMenuTriggerRestoreFocus]="false"
    aria-label="Profile" class="avatar-button menu-button" [class.active]="isMenuOpen('profile')"
    (menuOpened)="onMenuOpened('profile')" (menuClosed)="onMenuClosed('profile')">
    <div class="avatar-circle">
      <span class="avatar-initials">{{ userInitials() }}</span>
    </div>
  </button>
  <mat-menu #profilemenu="matMenu" class="topbar-dd card-with-shadow profile-menu">
    <!-- User Info Section -->
    <div class="p-x-32 p-y-16">
      <div class="d-flex align-items-center p-b-24 m-t-16">
        <div class="avatar-circle large unlink">
          @if(userProfile()?.picture) {
            <img [src]="userProfile()?.picture" alt="Profile picture" class="rounded-circle" />
          } @else {
            <span class="avatar-initials">{{ userInitials() }}</span>
          }
        </div>
        <div class="m-l-16">
          <h6 class="f-s-14 f-w-600 m-0 d-flex align-items-center">
            {{ userProfile()?.given_name }} {{ userProfile()?.family_name }}
            @if(userProfile()?.email_verified) {
              <span class="f-s-14 d-block text-success m-l-4">Verified</span>
            }
          </h6>
          <span class="text-muted email-ellipsis">{{ userProfile()?.email }}</span>
        </div>
      </div>
    </div>

    <!-- Settings Section (mobile only - theme toggle) -->
    <div class="profile-menu-section d-md-none">
      <div class="section-divider"></div>
      <div class="section-label p-x-32 p-y-8">
        <span class="f-s-12 f-w-500 text-muted">{{ 'layout.header.userMenu.settings' | translate }}</span>
      </div>
      <button mat-menu-item class="theme-toggle-item" (click)="toggleTheme(); $event.stopPropagation()">
        <div class="d-flex align-items-center justify-content-between w-100">
          <div class="d-flex align-items-center">
            <app-icon [icon]="isDarkTheme() ? 'solar:sun-line-duotone' : 'solar:moon-line-duotone'"
              customClass="icon-24 d-flex m-r-12" color="#0085db"></app-icon>
            <span class="f-s-14 f-w-500">
              {{ isDarkTheme() ? ('layout.header.userMenu.lightMode' | translate) : ('layout.header.userMenu.darkMode' | translate) }}
            </span>
          </div>
          <div class="theme-indicator">
            <app-icon [icon]="isDarkTheme() ? 'solar:moon-line-duotone' : 'solar:sun-line-duotone'"
              customClass="icon-20 d-flex text-muted"></app-icon>
          </div>
        </div>
      </button>
    </div>

    <!-- Sign Out Section -->
    <div class="profile-menu-section">
      <div class="section-divider"></div>
      <button mat-menu-item class="sign-out-item" (click)="logout()">
        <div class="d-flex align-items-center">
          <app-icon icon="solar:logout-2-line-duotone" customClass="icon-24 d-flex m-r-12 text-error"></app-icon>
          <span class="f-s-14 f-w-500 text-error">{{ 'layout.header.userMenu.signOut' | translate }}</span>
        </div>
      </button>
    </div>
  </mat-menu>
</mat-toolbar>